import React from 'react'

interface Props {
    current: string
}

const HanCircle: React.FC<Props> = ({current}) => {
    return (
        <div className={current} />
    )
}

export default HanCircle;